(() => {
  const SELECTORS = {
    root: '[data-contest-sale-notification]',
    data: '[data-contest-sale-notification-data]',
    close: '[data-contest-sale-notification-close]',
    initials: '[data-contest-sale-notification-initials]',
    title: '[data-contest-sale-notification-title]',
    order: '[data-contest-sale-notification-order]',
    time: '[data-contest-sale-notification-time]'
  };

  const CONFIG = {
    firstDelay: 1800,
    minDelay: 7000,
    maxDelay: 14000,
    visibleMs: 5200,
    dismissedMs: 120000
  };

  const parseEntries = () => {
    const node = document.querySelector(SELECTORS.data);
    if (!node) return [];

    try {
      const payload = JSON.parse(node.textContent || '{}');
      return Array.isArray(payload.entries)
        ? payload.entries
            .map((entry) => ({
              initials: String(entry.initials || '').trim(),
              orderId: String(entry.orderId || '').trim(),
              createdAt: String(entry.createdAt || '').trim()
            }))
            .filter((entry) => entry.initials && entry.orderId)
        : [];
    } catch (error) {
      return [];
    }
  };

  const randomBetween = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

  const formatOrderId = (orderId) => {
    const clean = String(orderId).trim();
    return clean.startsWith('#') ? clean : `#${clean}`;
  };

  const formatRelativeTime = (entry) => {
    const createdAt = Date.parse(entry.createdAt);
    if (Number.isFinite(createdAt)) {
      const diffSeconds = Math.max(1, Math.floor((Date.now() - createdAt) / 1000));
      if (diffSeconds < 60) return `acum ${diffSeconds} secunde`;

      const diffMinutes = Math.floor(diffSeconds / 60);
      if (diffMinutes < 60) return `acum ${diffMinutes} ${diffMinutes === 1 ? 'minut' : 'minute'}`;

      const diffHours = Math.floor(diffMinutes / 60);
      return `acum ${diffHours} ${diffHours === 1 ? 'ora' : 'ore'}`;
    }

    const seconds = randomBetween(18, 58);
    return `acum ${seconds} secunde`;
  };

  class ContestSaleNotification {
    constructor(root, entries) {
      this.root = root;
      this.entries = entries;
      this.closeButton = root.querySelector(SELECTORS.close);
      this.initialsNode = root.querySelector(SELECTORS.initials);
      this.titleNode = root.querySelector(SELECTORS.title);
      this.orderNode = root.querySelector(SELECTORS.order);
      this.timeNode = root.querySelector(SELECTORS.time);
      this.showTimer = null;
      this.hideTimer = null;
      this.dismissedUntil = 0;
      this.lastIndex = -1;
    }

    init() {
      if (!this.entries.length) return;

      this.closeButton?.addEventListener('click', () => {
        this.dismissedUntil = Date.now() + CONFIG.dismissedMs;
        this.hide();
        this.schedule(CONFIG.dismissedMs);
      });

      this.schedule(CONFIG.firstDelay);
    }

    getRandomEntry() {
      if (this.entries.length === 1) {
        this.lastIndex = 0;
        return this.entries[0];
      }

      let index = randomBetween(0, this.entries.length - 1);
      while (index === this.lastIndex) {
        index = randomBetween(0, this.entries.length - 1);
      }

      this.lastIndex = index;
      return this.entries[index];
    }

    render(entry) {
      const initials = entry.initials;

      if (this.initialsNode) this.initialsNode.textContent = initials;
      if (this.titleNode) this.titleNode.textContent = `${initials} s-a inscris in concurs`;
      if (this.orderNode) this.orderNode.textContent = formatOrderId(entry.orderId);
      if (this.timeNode) this.timeNode.textContent = formatRelativeTime(entry);
    }

    show() {
      if (Date.now() < this.dismissedUntil) return;

      this.render(this.getRandomEntry());
      this.root.hidden = false;
      window.requestAnimationFrame(() => {
        this.root.classList.add('is-visible');
      });

      window.clearTimeout(this.hideTimer);
      this.hideTimer = window.setTimeout(() => {
        this.hide();
        this.schedule(randomBetween(CONFIG.minDelay, CONFIG.maxDelay));
      }, CONFIG.visibleMs);
    }

    hide() {
      this.root.classList.remove('is-visible');
    }

    schedule(delay) {
      window.clearTimeout(this.showTimer);
      this.showTimer = window.setTimeout(() => this.show(), delay);
    }
  }

  const init = () => {
    const root = document.querySelector(SELECTORS.root);
    const entries = parseEntries();
    if (!root || !entries.length) return;

    const notification = new ContestSaleNotification(root, entries);
    notification.init();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
